module.exports = __webpack_public_path__ + "img/maptiler-logo.d73ffc21.svg";